import VideoPlayer from './src/VideoPlayer'
import _VideoPlayerMobile from './src/VideoPlayerMobile'

export const VideoPlayerMobile = _VideoPlayerMobile
export default VideoPlayer
